// tslint:disable:only-arrow-functions
// tslint:disable:object-literal-shorthand
// tslint:disable:space-before-function-paren
// tslint:disable:typedef
import { Unsubscribable } from 'rxjs';
import 'reflect-metadata';

export type NameableSubscription = Unsubscribable | [string, Unsubscribable];

export function Unsubscriber(params?: {
    destroyFunc: string,
    destroyTime: 'after' | 'before'
}) {

    return function (target) {
        params = {
            destroyFunc: 'ngOnDestroy',
            destroyTime: 'after',
            ...params
        };
        const unsubscribableLike: Map<any, {
            subscriptions: Unsubscribable[],
            namedSubscriptions: Map<string, Unsubscribable>,
            unsubscribe: () => void
        }> = new Map();
        const subscriber: string = Reflect.getMetadata('subscription:name', target.prototype, 'subscriber');

        Object.defineProperty(target.prototype, subscriber || 'subscriber', {
            get: function () {
                checkInstance(this);
                return unsubscribableLike.get(this).unsubscribe.bind(this);
            },
            set: function (subscription: Unsubscribable | [string, Unsubscribable]): void {
                checkInstance(this);
                const m = unsubscribableLike.get(this);
                if (Array.isArray(subscription)) {
                    if (m.namedSubscriptions.has(subscription[0])) {
                        const s = m.namedSubscriptions.get(subscription[0]);
                        if (s && typeof s.unsubscribe === 'function') {
                            s.unsubscribe();
                        }
                    }
                    m.namedSubscriptions.set(subscription[0], subscription[1]);
                } else {
                    m.subscriptions.push(subscription);
                }
            },
        });

        if (typeof target.prototype[params.destroyFunc] !== 'function') {
            throw new Error(`${target.prototype.constructor.name} must implement ${params.destroyFunc}() lifecycle hook`);
        }

        target.prototype[params.destroyFunc] = ngOnDestroyDecorator(target.prototype[params.destroyFunc]);

        function ngOnDestroyDecorator(f) {
            checkInstance(this);
            const m = unsubscribableLike.get(this);
            if (params.destroyTime === 'before') {
                return function () {
                    m.unsubscribe();
                    unsubscribableLike.delete(this);
                    return f.apply(this, arguments);
                };
            } else {
                return function () {
                    const res = f.apply(this, arguments);
                    m.unsubscribe();
                    unsubscribableLike.delete(this);
                    return res;
                };
            }
        }

        function checkInstance(instance: any): void {
            if (!unsubscribableLike.has(instance)) {
                unsubscribableLike.set(instance, {
                    subscriptions: [],
                    namedSubscriptions: new Map(),
                    unsubscribe: unsubscribe.bind(instance)
                });
            }
        }

        function unsubscribe(): void {
            checkInstance(this);
            const m = unsubscribableLike.get(this);
            const subs = [...m.subscriptions, ...Array.from(m.namedSubscriptions.values())]
                .filter(sub => sub && typeof sub.unsubscribe === 'function');
            subs.forEach(sub => sub.unsubscribe());
        }

        return target;
    };
}

export function UnsubscriberHandler() {
    return function (target, propertyKey: string | symbol) {
        Reflect.defineMetadata('subscription:name', propertyKey, target, 'subscriber');
    };
}
